import { render, staticRenderFns } from "./BrakingFoundation.vue?vue&type=template&id=c8f0b6d0&"
import script from "./BrakingFoundation.vue?vue&type=script&lang=js&"
export * from "./BrakingFoundation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports